import React, { FC } from 'react'
import { t, Trans } from '@lingui/macro'

import { Modal } from '../../../components/common/modal/Modal'
import { ButtonPrimary, ButtonClean } from 'front-end/src/components'

import Loader from '../../../components/common/loader/Loader'
import {
  useDuplicateTopicMutation,
  useCurrentTopicTitleQuery
} from './CopyResourceModal.codegen'

// TODO uncomment when ResourcesSubpage is refactored from class based component to FC
// import { useWorkspaceManageTopicsAndThemesQuery } from '../resources-subpage/workspaceManageTopicsAndThemes.codegen'
// import { useRouteMatch } from 'react-router-dom'

export const CopyResourceModal: FC<{
  show?: boolean
  topicId: number
  onHide: () => void
  onHidden?: () => void
}> = (props) => {
  // TODO uncomment when ResourcesSubpage is refactored from class based component to FC
  // const { params } = useRouteMatch<{ workspaceId: string }>()
  // const { refetch } = useWorkspaceManageTopicsAndThemesQuery({
  //   fetchPolicy: 'cache-first',
  //   variables: {
  //     workspaceId: Number(params.workspaceId)
  //   }
  // })

  const [duplicateTopic, { loading: copyInProgress }] =
    useDuplicateTopicMutation()

  const variables = { topicId: props.topicId }
  const { data, loading } = useCurrentTopicTitleQuery({
    variables: variables,
    fetchPolicy: 'cache-first'
  })

  return (
    <Modal
      header={t`Copy resource`}
      onHide={props.onHide}
      onHidden={props.onHidden}
      show={props.show}
      controls={[
        <ButtonClean key={1} onClick={props.onHide}>
          <Trans>Cancel</Trans>
        </ButtonClean>,
        <ButtonPrimary
          key={2}
          isLoading={copyInProgress}
          onClick={async () => {
            await duplicateTopic({ variables })

            props.onHide()
          }}
        >
          <Trans>Copy</Trans>
        </ButtonPrimary>
      ]}
    >
      {loading ? (
        <Loader />
      ) : (
        <p>
          <Trans>
            Do you want to create a copy of{' '}
            <strong>{data?.topic?.currentTitle}</strong> resource?
          </Trans>
        </p>
      )}
    </Modal>
  )
}
